import React from "react";
import * as Checkbox from "@radix-ui/react-checkbox";
import { CheckIcon } from "@radix-ui/react-icons";
import { cn } from "../../utils/cn";
import { useTranslation } from "react-i18next";

interface CheckboxInputProps {
  id?: string;
  label?: string;
  labelStyles?: string;
  checked?: boolean;
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
  readOnly?: boolean;
}

const CheckboxInput = ({
  id,
  label,
  labelStyles,
  checked = false,
  setChecked,
  readOnly = false,
}: CheckboxInputProps) => {
  const { i18n } = useTranslation();

  return (
    <div className="flex items-center">
      <div className="w-[15px]">
        <Checkbox.Root
          id={id}
          className={cn(
            "flex size-[15px] appearance-none items-center justify-center rounded bg-white border border-black outline-none",
            readOnly && "border-gray-400 cursor-not-allowed"
          )}
          checked={checked}
          onCheckedChange={() => !readOnly && setChecked?.((prev) => !prev)}
        >
          <Checkbox.Indicator className="text-violet11">
            <CheckIcon />
          </Checkbox.Indicator>
        </Checkbox.Root>
      </div>
      <label
        htmlFor={id}
        className={cn(
          "text-sm leading-none cursor-pointer",
          labelStyles,
          i18n.language === "en" ? "pl-[10px]" : "pr-[10px]",
          readOnly && "text-gray-400 cursor-not-allowed"
        )}
      >
        {label}
      </label>
    </div>
  );
};

export default React.memo(CheckboxInput);
